module.exports = __webpack_public_path__ + "img/1454436401.106d11e7.jpg";